<template>
    <div class="configurator-personalize container">
        <input type="hidden" v-model="section">
        <div v-scroll-spy="{data: 'section', offset: 250}">
            <div v-if="bikeSelected === 1">
                <div class="d-md-none">
                    <MainTitle :title="bikeName"></MainTitle>
                    <MainTitle :title="$t('personalize.mainTitle')" id="personalize" v-if="bikeSelected" />
                    <BikePicture v-if="bikeSelected" :url="bikeImage" />
                    <LoadConfigurationNumber textAlign="text-md-right" />
                </div>
                <div class="row d-none d-md-flex">
                    <div class="col-12 col-md-7 col-xl-8">
                        <MainTitle :title="bikeName"></MainTitle>
                        <MainTitle :title="$t('personalize.mainTitle')" id="personalize" v-if="bikeSelected" />
                    </div>
                    <div class="col-12 col-md-5 col-xl-4">
                        <LoadConfigurationNumber textAlign="text-md-right" />
                    </div>
                    <BikePicture v-if="bikeSelected" :url="bikeImage" />
                </div>
            </div>
            <!--
            <div v-else-if="bikeSelected === 2">
                <div class="row">
                    <div class="col-12 col-md-6">
                        <SubTitle :title="$t('personalize.initNewConfigTitle')" />
                        {{ $t('personalize.initNewConfigText') }}<br/>
                        <a v-if="langSelected === 'de' || langSelected === 'at' || langSelected === 'ch'" href="https://tout-terrain.de/de/die-produkte/" class="btn btn-secondary">{{ $t('personalize.initNewConfigButton') }}</a>
                        <a v-else href="https://tout-terrain.de/en/the-products/" class="btn btn-secondary">{{ $t('personalize.initNewConfigButton') }}</a>
                    </div>
                    <div class="col-12 col-md-6">
                        <SubTitle :title="$t('personalize.initLoadConfigTitle')" />
                        {{ $t('personalize.initLoadConfigText') }}<br/>
                        <LoadConfigurationNumber textAlign="text-md-left" />
                    </div>
                </div>
            </div>-->


            <!--<div class="locale-changer">
                <select v-model="langSelected" @change="changeLocale($event)">
                    <option v-for="(lang, i) in langs" :key="`Lang${i}`" :value="lang">{{ lang }}</option>
                </select>
            </div>-->

            <div v-if="bikeSelected === 1">
                <SubTitle :title="$t('personalize.subTitle1')" id="equipment" />
                <div v-for="(item, index) in groups" :key="index">
                    <div v-if="item.Groupname === 'Rahmengröße'">
                        <SelectButtons v-if="renderFrameSize" :ref="'selectButtons_' + item.Characteristic" :title="item.Group" :group="item.Groupname" :characteristic="item.Characteristic"
                            :bikeName="bikeName" :bikeCode="bikeCode" :bikeImage="bikeImage" :bikePrice="bikePrice"></SelectButtons>
                    </div>
                    <div v-if="item.Groupname === 'Schaltungstyp'">
                        <SelectButtons v-if="renderCircuitType" :ref="'selectButtons_' + item.Characteristic" :title="item.Group" :group="item.Groupname" :characteristic="item.Characteristic"></SelectButtons>
                    </div>
                    <div v-if="item.Groupname === 'Ausstattung'">
                        <SelectButtons v-if="renderEquipment" :ref="'selectButtons_' + item.Characteristic" :title="item.Group" :group="item.Groupname" :characteristic="item.Characteristic"></SelectButtons>
                    </div>
                    <div v-else-if="item.Groupname === 'Rahmenfarbe'">
                        <SelectColor v-if="renderFrameColor" :ref="'selectButtons_' + item.Characteristic" :title="item.Group" :image="bikeImage" :group="item.Groupname"/>
                    </div>
                </div>
            </div>

            <div v-if="getNavState() == ''">
                <SubTitle v-if="bikeSelected === 1 && renderMoreOptions" :title="$t('personalize.subTitle2')" id="more_options" />

                <div v-if="bikeSelected === 1 && renderMoreOptions" v-for="(item, index) in groups">

                    <div v-if="item.Groupname !== 'Ausstattung' && item.Groupname !== 'Rahmengröße' && item.Groupname !== 'Schaltungstyp' && item.Groupname !== 'Schaltung' && item.Groupname !== 'Rahmenfarbe' && item.Groupname !== 'Zubehör'">
                        <SelectCombobox :ref="'selectCombobox_' + item.Groupname" :title="item.Group" :group="item.Groupname" />
                    </div>
                </div>
            </div>

        </div>

        <div class="modal fade" id="selectModal" tabindex="-1" role="dialog">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="InfoTitle"></h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <i class="fal fa-times"></i> Schließen
                        </button>
                    </div>
                    <div class="modal-body" id="infoMessage"></div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>

// @ is an alias to /src
import MainTitle                from '@/components/MainTitle.vue'
import SubTitle                 from '@/components/SubTitle.vue'
import LoadConfigurationNumber  from '@/components/LoadConfigurationNumber.vue'
import BikePicture              from '@/components/BikePicture.vue'
import SelectButtons            from '@/components/SelectButtons.vue'
import SelectColor              from '@/components/SelectColor.vue'
import SelectCombobox           from '@/components/SelectCombobox.vue'

export default {
    name: 'personalize',
    components: {
        MainTitle,
        SubTitle,
        LoadConfigurationNumber,
        BikePicture,
        SelectButtons,
        SelectColor,
        SelectCombobox
    },
    data() {
        return {
            // refresh components
            renderFrameSize: true,
            renderCircuitType: false,
            renderEquipment: false,
            renderFrameColor: false,
            renderMoreOptions: false,

            bikeName: '',
            bikeSelected: 0,
            bikeCode: '',
            bikeImage: '',
            bikePrice: 0,

            groups: null,
            page: 'personalize',

            stateCounter: 0,

            langs: ['de', 'en', 'fr'],
            langSelected: 'de',

            loadComponent: 0,
            section: 0,
        }
    },
    watch: {
        section: function(val) {
            this.$parent.step = val;
        }
    },
    methods: {
        loadConfig: function(configKey) {

            let app = this;
            let parent = app.$parent;
            let params = new URLSearchParams();
            params.append('apikey', this.$apikey);
            params.append('apipassword', this.$apipassword);
            params.append('ConfigKey', configKey);
            params.append('CustomerID', parent.customerID);
            parent.loading = true;

            app.loadConfigPost(app,parent,params);
        },
        loadConfigPost(app,parent,params) {
            this.$http.post(this.$apiurl + '/api/LoadConfig', params)
                .then(response => {
                    if(response.data['TransferData']['Message']) {
                        app.$parent.popupInfoText = response.data['TransferData']['Message'];
                        app.$parent.popupInfo = true;
                        app.$parent.loading = false;
                    }

                    if(response.data['TransferData']['doRefreshGroups'])
                    {
                        app.bikeSelected = 1;
                        app.$parent.bikeSelected = 1;
                        app.$parent.step = 4;
                        app.$parent.bikeName = response.data['TransferData']['ModelName'];
                        app.$parent.ConfigurationID = response.data['TransferData']['ConfigurationID'];
                        app.getGroups(response.data['TransferData']['ConfigurationID']);

                        this.$router.push({ path: 'your-bike' });
                    }
                })
                .catch(error => {
                    app.loadConfigPost(app,parent,params);
                })
        },
        getNavState: function() {
            if(this.$parent.nav === true)
            {
                return '';
            } else {
                return 'nav-item-disabled';
            }
        },
        changeLocale: function(event) {
            let container = $('body');
            container.css('opacity', '0.5');

            parent.bikeSelected = false;
            if(event.target.value === 'de') {
                this.lang = 1;
                window.$cookies.set('lang', this.lang);
            } else if(event.target.value === 'en') {
                this.lang = 2;
                window.$cookies.set('lang', this.lang);
            } else if(event.target.value === 'fr') {
                this.lang = 3;
                window.$cookies.set('lang', this.lang);
            }
            this.groups = null;
            this.createConfig(window.$cookies.get('bike'), this.lang, this.$parent.countryCode);

            this.$i18n.locale = event.target.value;
        },
        // create config
        async createConfig(bike, lang, country) {
            let app = this;
            let parent = app.$parent;
            let params = new URLSearchParams();
            let errorCounter = 0;
            params.append('apikey', this.$apikey);
            params.append('apipassword', this.$apipassword);
            params.append('LanguageID', lang);
            params.append('CountryCode', country);
            params.append('CustomerID', parent.customerID);
            parent.popupError = false;

            await app.createConfigPost(app,parent,bike,params,errorCounter);
        },
        createConfigPost(app,parent,bike,params,errorCounter) {
            this.$http.post(this.$apiurl + '/api/CreateConfig/' + bike, params)
                .then(response => {
                    parent.ConfigurationID = response.data['TransferData']['ConfigurationID'];
                    app.bikeImage = response.data['TransferData']['Image'];
                    app.bikeCode = response.data['TransferData']['Article'];
                    if(response.data['TransferData']['doRefreshGroups'])
                    {
                        app.getGroups(response.data['TransferData']['ConfigurationID']);
                    }
                })
                .catch(error => {
                    if (error.response.status === 500 || error.response.status === 502 || error.response.status === 503 || error.response.status === 504) {
                        errorCounter++;
                        if(errorCounter<= 25) {
                            setTimeout(function () {
                                app.createConfigPost(app,parent,bike,params,errorCounter);
                            }, 250)
                        } else {
                            parent.popupError = true;
                        }
                    } else {
                        parent.popupError = true;
                    }
                })
        },
        // get groups from api
        async getGroups(ConfigurationID) {
            let app = this;
            let parent = app.$parent;
            let params = new URLSearchParams();
            let errorCounter = 0;
            params.append('apikey', this.$apikey);
            params.append('apipassword', this.$apipassword);
            params.append('ConfigurationID', ConfigurationID);
            params.append('CustomerID', parent.customerID);
            parent.popupError = false;

            await app.getGroupsPost(app,parent,params,errorCounter);
        },
        getGroupsPost(app,parent,params,errorCounter) {
            this.$http.post(this.$apiurl + '/api/GetGroups', params)
                .then(response => {
                    app.groups = response.data['ReturnData'];
                    app.bikeImage = response.data['TransferData']['Image'];
                    if(response.data['TransferData']['Price'])  {
                        parent.priceSymbol = response.data['TransferData']['PriceSymbol'];
                        parent.price = response.data['TransferData']['Price'].toFixed(2).replace('.', ',') + ' ' + parent.priceSymbol;
                        parent.vat = response.data['TransferData']['InclVat'] || 0;
                    }

                    if(app.groups.length > 4) app.renderMoreOptions = true;
                })
                .catch(error => {
                    if (error.response.status === 500) {
                        errorCounter++;
                        if(errorCounter<= 25) {
                            setTimeout(function () {
                                app.getGroupsPost(app,parent,params,errorCounter);
                            }, 250)
                        } else {
                            parent.popupError = true;
                        }
                    } else {
                        parent.popupError = true;
                    }
                })
        }
    },
    async mounted() {
        // init lang
        if(this.$route.query.lang === 'de') {
            this.$i18n.locale = this.$route.query.lang;
            this.langSelected = this.$route.query.lang;
            this.$parent.lang = 1;
        } else if(this.$route.query.lang === 'en') {
            this.$i18n.locale = this.$route.query.lang;
            this.langSelected = this.$route.query.lang;
            this.$parent.lang = 2;
        } else if(this.$route.query.lang === 'fr') {
            this.$i18n.locale = this.$route.query.lang;
            this.langSelected = this.$route.query.lang;
            this.$parent.lang = 3;
        } else if(this.$parent.lang) {
            if(this.$parent.lang === '1') {
                this.$i18n.locale = 'de';
                this.langSelected = 'de';
            } else if(this.$parent.lang === '2') {
                this.$i18n.locale = 'en';
                this.langSelected = 'en';
            } else if(this.$parent.lang === '3') {
                this.$i18n.locale = 'fr';
                this.langSelected = 'fr';
            }

        }

        // init country
        if(this.$route.query.country) {
            this.$parent.countryCode = this.$route.query.country;
        }

        // init id
        if(this.$route.query.id) {
            this.$parent.customerID = this.$route.query.id;
        }

        // init destination
        if(this.$route.query.destination) {
            this.$parent.destination = this.$route.query.destination;
        }

        // init cartId
        if(this.$route.query.shopifyCartId) {
            this.$parent.cartId = this.$route.query.shopifyCartId;
        }

        if(this.$route.query.shopifyShopDomain) {
            this.$parent.shopDomain = this.$route.query.shopifyShopDomain;
        }

        // init bike config
        let configKey = this.$route.query.number;
        if(configKey) {
            this.loadConfig(configKey);
        } else {
            $('.configurator-personalize #section').on('change', function() {
                this.$parent.step = $(this).val();
            });

            // init modal
            $('#selectModal').on('show.bs.modal', function (event) {
                let button = $(event.relatedTarget) // Button that triggered the modal
                let title = button.data('title');
                let message = button.data('message');

                let modal = $(this);
                modal.find('#InfoTitle').text(title);
                modal.find('#infoMessage').html(message);
            })

            // select view
            this.$parent.loading = true;

            // init configuration and bike
            if(this.$route.query.ordernumber)
            {
                this.$parent.bikeName = this.$route.query.bike.replace(/-/g, ' ');
                this.bikeName = this.$parent.bikeName;
                this.bikePrice = this.$parent.price === 0 ? 1 : this.$parent.price;
                this.bikeSelected = 1;
                this.$parent.bikeSelected = 1;
                await this.createConfig(this.$route.query.ordernumber, this.$parent.lang, this.$parent.countryCode);
                /*
                window.onbeforeunload = function() {
                    return 'You have unsaved changes!';
                }*/
            }
            else if(this.$parent.ConfigurationID && !this.$route.query.bike)
            {
                this.bikeName = this.$parent.bikeName;
                this.bikePrice = this.$parent.price === 0 ? 1 : this.$parent.price;
                this.bikeSelected = 1;
                this.$parent.bikeSelected = 1;
                await this.getGroups(this.$parent.ConfigurationID);
                window.onbeforeunload = function() {
                    return 'You have unsaved changes!';
                }
            } else {
                this.bikeSelected = 2;
                this.$parent.bikeSelected = 2;
                location.href='https://tout-terrain.de/konfigurator';
            }
        }

        this.$parent.channel = this.$route.query.channel;
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .configurator-personalize {
        margin-bottom: 200px;
        min-height: 1700px;
    }
    #selectModal {
        padding-right: 0 !important;
    }
    #selectModal .modal-dialog {
        max-width: none;
        margin: 0;
        height: 100%;
    }
    #selectModal .modal-dialog .modal-content {
        height: 100%;
        border-radius: 0;
        border: 0;
    }
    #selectModal .modal-dialog .modal-content .modal-header .modal-title {
        font-size: 24px;
        font-weight: bold;
        line-height: 1.2;
        letter-spacing: 0.38px;
        text-transform: uppercase;
    }
    #selectModal .modal-dialog .modal-content .modal-header .close {
        font-size: 10px;
        line-height: 1.2;
        letter-spacing: 0.42px;
        text-align: center;
        color: #131313;
        opacity: 1;
    }
    #selectModal .modal-dialog .modal-content .modal-header .close:hover {
        color: #ec7205;
    }
    #selectModal .modal-dialog .modal-content .modal-header .close i {
        font-size: 42px;
        display: block;
    }
    #selectModal .modal-dialog .modal-content .modal-body {
        line-height: 2;
        font-size: 15px;
        overflow: auto;
    }
    #selectModal .modal-dialog .modal-content .modal-body >>> .description  {
        color: #131313;
        line-height: 1.4;
        font-weight: bold;
        margin-bottom: 20px;
    }
    #selectModal .modal-dialog .modal-content .modal-body >>> strong {
        font-weight: bold;
    }

    #selectModal .modal-dialog >>> ul {
        padding-inline-start: 0px;
        list-style: none;
    }
    #selectModal .modal-dialog >>> ul li {
        padding: 5px;
    }
    #selectModal .modal-dialog >>> ul li:nth-child(odd) {
        background-color: #eeeeee;
    }

    @media (min-width: 768px) {
        #selectModal .modal-dialog {
            max-width: 600px;
            margin: 100px auto;
            height: auto;
        }
    }
</style>